import { Typography, Stack, Card, CardContent } from "@mui/material";
import { useGetIdentity } from "../../hooks/useGetIdentity";
import { Loading, useGetOne } from "react-admin";

export const AdvertiserLinksBought = () => {
  const { data: identity } = useGetIdentity();
  const advertiserId = identity?.id;
  const { data: advertiser, isLoading: advertiserLoading } = useGetOne(
    "v1_ContactBase",
    {
      id: advertiserId,
    },
    { enabled: !!advertiserId }
  );
  
  if (advertiserLoading) return <Loading />;

  const amountFormatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
  
  return (
    <Card>
      <CardContent>
        <Stack>
          <Typography variant="h3">Links Bought</Typography>
          <Stack direction="row" spacing={6}>
            <Stack>
              <Typography color="text.secondary">Total</Typography>
              <Typography variant="h1">
                {amountFormatter.format(advertiser.links_bought_total)}
              </Typography>
            </Stack>
            <Stack>
              <Typography color="text.secondary">Last month</Typography>
              <Typography variant="h1" color="secondary.main">
                {amountFormatter.format(advertiser.links_bought_last_month)}
              </Typography>
            </Stack>
            <Stack>
              <Typography color="text.secondary">This month</Typography>
              <Typography variant="h1" color="primary">
                {amountFormatter.format(advertiser.links_bought_this_month)}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
